<script>
export default {
  props: ['urlToService', 'Settings', 'componentTexts', 'iconPaths'],
  data() {
    return {
      loading: false,
      settings: {},
      files: [],
      pdf: this.iconPaths.pdf,
      doc: this.iconPaths.doc,
      ppt: this.iconPaths.ppt,
      xls: this.iconPaths.xls,
      file: this.iconPaths.file,
      showChanged: false
    };
  },
  async created() {
    await this.init(this.urlToService, this.Settings);
  },
  methods: {
    async init(url, settings) {
      try {
        debugger;
        this.loading = true;
        await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body:
            'RequestPackageType=' +
            encodeURIComponent(JSON.stringify(settings)),
        })
          .then((res) => res.json())
          .then((response) => {
            // console.log('Success:', response);
            const { Settings, Files } = response;

            if (Settings) {
              this.settings = Settings;
              this.showChanged = Settings?.columns?.includes("Changed") || false;
            }
            if (Files) {
              this.files = Files;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="filebrowserblock vld-parent">
    <vloading
      :height="32"
      :width="32"
      :color="'#404040'"
      :is-full-page="false"
      :active.sync="loading"></vloading>
    <div class="filebrowserblock--container" v-if="files.length > 0">
      <h2
        v-if="settings && settings.ListHeading"
        class="heading-level-2"
        v-html="settings.ListHeading"></h2>
      <ul class="files">
        <li v-for="(item, index) in files" :key="index">
          <div class="d-flex flex-row">
            <div class="files--icon">
              <img v-if="item.Extension == 'pdf'" :src="pdf" />
              <img v-else-if="item.Extension == 'doc'" :src="doc" />
              <img v-else-if="item.Extension == 'ppt'" :src="ppt" />
              <img v-else-if="item.Extension == 'xls'" :src="xls" />
              <img v-else :src="file" />
            </div>
            <a
              :href="item.NavigateUrl"
              target="_blank"
              rel="noreferrer"
              download
              class="files--info">
              <p class="files--title">{{ item.Name }} <template v-if="showChanged">{{ item.Changed }}</template></p>
              <p class="files--extension">
                {{ item.Extension }}
              </p>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
